<!-- Dialog title -->
<div class="d-flex justify-content-end">
  <div class="cross-btn">
    <img
      src="assets/icon/cross.svg"
      class="cursor-pointer"
      alt="close"
      (click)="onClose()"
    />
  </div>
</div>

<div mat-dialog-title class="ps-3 pe-3 pb-3">
  <div class="row mt-3">
    <div class="col-lg-6 col-md-11 col-11 image-cover">
      <img src="assets/icon/otp.svg" class="otp-image" alt="close" />
    </div>
    <div class="col-1 res-cross-btn">
      <img
        src="assets/icon/cross.svg"
        class="cursor-pointer"
        alt="close"
        (click)="onClose()"
      />
    </div>

    <div class="col-lg-6 col-md-12 col-12">
      <div>
        <span class="enter-otp">
          Enter <span class="otp">OTP</span> generated on
          {{ communicationData?.mobile_no }} and
          {{ communicationData?.mail_id }}
        </span>
      </div>
      <div mat-dialog-content>
        <div>
          <span class="otp-header asterik-mandtry">OTP</span>
        </div>
        <form>
          <div class="row">
            <div class="col-lg-12 col-12 col-md-12">
              <ng-otp-input
                #ngOtpInput
                (onInputChange)="onOtpChange($event)"
                [config]="config"
                class="custom-otp-input"
              ></ng-otp-input>
            </div>
            <div class="col-lg-12 col-12 resend-otp-msg text-end">
              <div>
                <div *ngIf="resendDisabled">
                  <span class="expire">
                    Resend
                    <ng-container *ngIf="resendDisabled">
                      in <span class="otp-count">{{ countdown }}</span> seconds
                    </ng-container>
                    <ng-container *ngIf="!resendDisabled && countdown <= 0">
                      OTP
                    </ng-container>
                  </span>
                </div>
              </div>
              <a
                *ngIf="!resendDisabled"
                class="resend-otp mt-1"
                (click)="resendotp()"
                [ngClass]="{ 'disabled-link': loader }"
              >
                Resend OTP
              </a>
            </div>
            <div class="col-12 mt-3">
              <button
                class="submit-btn otp-submission"
                type="submit"
                (click)="loader ? null : verify()"
                [disabled]="btnDisable"
              >
                <img
                  src="assets/gif/button-loader.gif"
                  alt="close"
                  class="loader me-2"
                  *ngIf="loader"
                />
                Verify & Proceed
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [hidden]="true" [innerHTML]="myform" #myform></div>
